import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_written_recs_of_suggestions_and_feedback_maintained_for_at'

export const dataPointDefinition = {
  retracedId: 'are_written_recs_of_suggestions_and_feedback_maintained_for_at',
  name: 'Are written records of suggestions and feedback maintained for at least 12 months?',
  description:
    'Answer Not Applicable means that the facility does not engage with workers to proactively seek suggestions and feedback.',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-work-2',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13290,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
